import React, { useRef, useEffect } from 'react'
import { graphql } from 'gatsby'
import style from './forms.mod.scss'
import { Content } from '@components'
import FormsDitchTheScales from './forms-ditch-the-scales'
import FormsContact from './forms-contact'
import ZapierForm from 'react-zapier-form'
import { postSend } from '@helpers/gtmHelpers'
import smoothscroll from 'smoothscroll-polyfill'

const Form = ({
  heading,
  leadNode,
  successMessage = 'Thank you for your message, we will be in touch shortly.',
  formType,
  zapierWebhook
}) => {
  const inputs = {
    type: useRef(null),
    subject: useRef(null),
    optIn: useRef(null),
    emailAddress: useRef(null)
  }

  useEffect(() => {
    smoothscroll.polyfill()
  }, [])

  return (
    <ZapierForm
      action={zapierWebhook}
      onSuccess={e => postSend(e, formType, inputs, formType === 'Contact')}
    >
      {({ error, success }) => {
        return (
          <>
            <div className={style.form}>
              <h3>{heading}</h3>
              {leadNode?.childMarkdownRemark?.html && (
                <Content contentNode={leadNode} addLastMargin />
              )}
              {!error && !success && (
                <>
                  {formType === 'Ditch the Scales' && (
                    <FormsDitchTheScales inputs={inputs} />
                  )}
                  {formType === 'Contact' && <FormsContact inputs={inputs} />}
                </>
              )}
              {error && (
                <div className={style.form__error}>
                  <p>{'Something went wrong. Please try again later.'}</p>
                </div>
              )}
              {success && (
                <div className={style.form__success}>
                  <p>{successMessage}</p>
                </div>
              )}
            </div>
            {/* Misc Tracking fields */}
            <input
              type="hidden"
              name="type"
              ref={inputs.type}
              value={formType}
            />
          </>
        )
      }}
    </ZapierForm>
  )
}

export default Form

export const query = graphql`
  fragment Form on DatoCmsForm {
    id
    model {
      apiKey
    }
    background
    heading
    formType
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    padding
    zapierWebhook
    successMessage
  }
`
